import React from "react";
import FBITable from "./FBITable/FBITable";

export default function FBICard(props) {
    const { fbi_data } = props
    const hasSource = Object.keys(fbi_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                FBI - Match encontrado
            </p>
            <FBITable fbi_data={fbi_data.source} />
        </div>
    )
}
